angular.module('app').factory('casinoGameService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoGame/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            get: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            getSkinGames: function (requestData) {
                return restAngular.
                    one("getSkinGames").
                    customGET(param(requestData))
            },
            edit: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            editSkinGame: function (requestData) {
                return restAngular.
                    one("changeSkinGame").
                    post("", requestData)
            },
            changeOrder: function (requestData) {
                return restAngular.
                    one("changeOrder").
                    post("", requestData)
            },
            changeOrderSkinGames: function (requestData) {
                return restAngular.
                    one("changeOrderSkinGames").
                    post("", requestData)
            },
            deleteGame: function (gameId) {
                var requestData = {
                    id: gameId,
                    status: "archive"
                };
                return restAngular.
                    one("change").
                    post("", {casinoGame: requestData})
            },
            publishGame: function (gameId) {
                var requestData = {
                    id: gameId,
                    status: "published"
                };
                return restAngular.
                    one("change").
                    post("", {casinoGame: requestData})
            },
            switchSkins: function (requestData) {
                return restAngular.
                    one("switchSkins").
                    post("", requestData)
            }
        }
    }
]);